import { userPermissions } from "@redotech/redo-model/permissions";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getUserPermissions = {
  name: "getUserPermissions" as const,
  input: z.object({}),
  output: z.object({
    permissions: zExt.filterToValidArray(createEnum(userPermissions)),
  }),
  mock: { permissions: [...userPermissions] },
};
